import { ReactNode, useState } from 'react'

import { AssociationsModal, HelperWrapper, ManualAccountAddModal } from 'src/components'
import {
  AssociationsType,
  IStepAccountsConnectionRespDto,
  IStepFormSelectedAccount,
} from 'src/types'

import useStyles from 'src/components/associations/styles'
import { AccountConnectionsList } from './connections-list.component'
import { AccountManualContextProvider } from './contexts'

interface Props {
  isDisabled?: boolean
  description: string | ReactNode
  selectedItem: IStepFormSelectedAccount | null
  handleSelectItem: (value: string) => void
  handleToggleSwitchItem: () => void
  isRound?: boolean
  connections: IStepAccountsConnectionRespDto[]
}

const StepAccountAssociations = ({
  description,
  isRound,
  selectedItem,
  handleSelectItem,
  handleToggleSwitchItem,
  connections,
  isDisabled,
}: Props) => {
  const classes = useStyles({ isRoundImage: isRound })
  const [open, setOpen] = useState(false)
  const [openManual, setOpenManual] = useState(false)

  const handleOpenManual = () => setOpenManual(true)
  const handleCloseManual = () => setOpenManual(false)

  const handleOpenModal = () => {
    setOpen(true)
  }

  const handleCloseModal = () => {
    setOpen(false)
  }

  const selectionCount = selectedItem ? 1 : 0

  return (
    <>
      <div className={classes.bigContainer}>
        <div className={classes.text}>{description}</div>
        <div className={classes.textCounter}>
          {selectionCount} <HelperWrapper t="edit-account-title-2" />
        </div>
        <AccountConnectionsList
          isDisabled={isDisabled}
          selectedItem={selectedItem}
          items={connections}
          handleSelectItem={handleSelectItem}
          handleToggleSwitchItem={handleToggleSwitchItem}
        />
        <AccountManualContextProvider handleOpen={handleOpenManual}>
          <AssociationsModal
            type={AssociationsType.ACCOUNTS}
            open={open}
            isImageRound={isRound}
            selectedItems={selectedItem ? [selectedItem.id] : []}
            handleCloseModal={handleCloseModal}
            handleSelectItem={handleSelectItem}
          />
        </AccountManualContextProvider>
        <input
          width={'100%'}
          name="image"
          accept="image/*"
          id={`accounts-connection`}
          type="checkbox"
          multiple
          hidden
          onChange={handleOpenModal}
        />
      </div>
      {!isDisabled && (
        <ManualAccountAddModal
          handleSelectItem={handleSelectItem}
          open={openManual}
          handleClose={handleCloseManual}
        />
      )}
    </>
  )
}

export { StepAccountAssociations }
